// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Xi1mu","page":"styles_page__NJlpU","footer":"styles_footer__9lMbq","button":"styles_button__tz8Lg"};